import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://travelguide.cr';

export const useCanonical = () => {
  const location = useLocation();

  useEffect(() => {
    // Get or create canonical link element
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }

    // Build canonical URL (without query params or trailing slashes)
    let path = location.pathname;
    
    // Remove trailing slash except for homepage
    if (path !== '/' && path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    const canonicalUrl = `${BASE_URL}${path}`;
    canonicalLink.setAttribute('href', canonicalUrl);

  }, [location.pathname]);
};

export default useCanonical;
